import axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react'
import { useAppSelector } from '../../store/hooks';
import RaporCard from './RaporCard';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Button } from "primereact/button";

export default function IlRapor() {
  const pdf = new jsPDF('landscape', undefined, 'A4');
  const iller = useAppSelector(state => state.sharedState.iller);
  const copyIller = JSON.parse(JSON.stringify(iller));
  copyIller.unshift({
    adi: 'Tüm İller',
    id: 0
  });

  const token = useAppSelector(state => state.authState.token);
  const [provinceID, setProvinceID] = useState(0);
  const [reportData, setReportData] = useState<any>(undefined);
  const [osbList, setOsbList] = useState<any>(undefined);
  var areaFormatter: any = new Intl.NumberFormat();
  const pdfPage = document.getElementById("tab3") as HTMLElement;

  const downloadPdf = () => {
    let page: any
    page = pdfPage

    html2canvas(page).then((canvas: any) => {
      pdf.addImage(canvas, "PNG", 10, 10, 270, 150);
      pdf.save("İl Raporu.pdf");
    });
  };

  useEffect(() => {
    getData();
    getOsbler();
  }, [provinceID])

  const getData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/il/${provinceID}?token=${token}`)

    const reportData = response.data;

    setReportData(reportData);

    setTimeout(() => {
      const barWithoutAxis3 = new (window as any).Highcharts.Chart('il_bar', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'bar',
          backgroundColor: '#1f2d40',
        },
        xAxis: {
          categories: reportData.parselData.map((parselObject: any) => parselObject.range),
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: `{point.y}`
        },
        title: {
          text: `Boş Parsel Büyüklükleri`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          data: reportData.parselData.map((parselObject: any) => Number(parselObject.count)),
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });

      const pie1 = new (window as any).Highcharts.Chart('il_parsel_bar', {
        colors: ['#008184', '#005455', '#b68a33', '#60471c'],
        chart: {
          type: 'pie',
          backgroundColor: '#1f2d40',
          options3d: {
            enabled: true,
            alpha: 45
          }
        },
        exporting: {
          enabled: false
        },
        title: {
          text: 'Toplam Parsel Bilgisi',
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'left'
        },
        legend: {
          enable: true,
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle',
          itemStyle: { "color": "#ffffff", "fontSize": "10px" }
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            innerSize: '50%',
            depth: 20,
            dataLabels: {
              enabled: false
            },
            showInLegend: true,
          }
        },
        series: [{
          name: 'Brands',
          data: [[
            'İnşaat Halinde Parsel Sayısı',
            Number(reportData.parselAsamaData[0].total),
          ], [
            'Proje Halindeki Parsel Sayısı',
            Number(reportData.parselAsamaData[1].total),
          ], [
            'Üretime Geçen Parsel Sayısı',
            Number(reportData.parselAsamaData[2].total)
          ],]
        }]
      });

      // const totalParsel = Number(reportData.parselNitelikData[0].count);
      const totalParsel = parseFloat(Number(reportData.parselNitelikData[0].count).toLocaleString());
      // const tahsisParsel = Number(reportData.parselNitelikData[1].count);
      const tahsisParsel = Number(reportData.parselNitelikData[2].count.toLocaleString());
      const sanayiParsel = Number(reportData.parselNitelikData[1].count.toLocaleString());

      const totalParselArea = parseFloat((reportData.parselAreaData[1].area).toFixed(2));
      const tahsisParselArea = parseFloat((reportData.parselAreaData[0].area));

      // const uretimParsel = Number(reportData.parselAsamaData[2].total);
      const uretimParsel = parseFloat(Number(reportData.parselAsamaData[2].total).toLocaleString());
      
      const tahsisPercentage = parseFloat((Number((tahsisParsel / totalParsel)) * 100).toFixed(2));
      const uretimPercentage = parseFloat((Number((uretimParsel / totalParsel).toFixed(2)) * 100).toFixed(2));

      const emptyParcelCount = parseFloat(Number(sanayiParsel - tahsisParsel).toFixed(2));
      const emptyParcelArea = parseFloat((totalParselArea - tahsisParselArea).toFixed(2));
      // const emptyParcelArea = Number((totalParselArea - tahsisParselArea).toFixed(2));

      const barWithoutAxis = new (window as any).Highcharts.Chart('il_doluluk', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'column',
          backgroundColor: '#1f2d40',
          options3d: {
            enabled: true,
            alpha: 0,
            beta: 5,
            depth: 30,
            viewDistance: 5
          },
          marginLeft: 3
        },
        xAxis: {
          gridLineWidth: 0,
          categories: ['Sanayi Parseli Doluluk Oranı', 'Sanayi Parseli Üretim Doluluk Oranı'],
          labels: {
            enabled: true,
            style: { "color": "#ffffff", "fontSize": "10px" }
          },
          title: {
            enabled: false
          }
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: '%{point.y}'
        },
        title: {
          text: `Parsel Doluluk Oranı`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          pointWidth: 110,
          data: [tahsisPercentage, uretimPercentage],
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });

      new (window as any).Highcharts.Chart('parsel_alan', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'column',
          backgroundColor: '#1f2d40',
          options3d: {
            enabled: true,
            alpha: 0,
            beta: 5,
            depth: 30,
            viewDistance: 5
          },
          marginLeft: 3
        },
        xAxis: {
          gridLineWidth: 0,
          categories: ['Toplam Parsel Alanı (ha)', 'Toplam Boş Parsel Alanı (ha)'],
          labels: {
            enabled: true,
            style: { "color": "#ffffff", "fontSize": "10px" }
          },
          title: {
            enabled: false
          }
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: '{point.y}'
        },
        title: {
          text: `Toplam Parsel Alanı`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          pointWidth: 110,
          data: [totalParselArea, emptyParcelArea],
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });

      new (window as any).Highcharts.Chart('parsel_sayi', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'column',
          backgroundColor: '#1f2d40',
          options3d: {
            enabled: true,
            alpha: 0,
            beta: 5,
            depth: 30,
            viewDistance: 5
          },
          marginLeft: 3
        },
        xAxis: {
          gridLineWidth: 0,
          categories: ['Toplam Sanayi Parsel Sayısı', 'Toplam Boş Parsel Sayısı'],
          labels: {
            enabled: true,
            style: { "color": "#ffffff", "fontSize": "10px" }
          },
          title: {
            enabled: false
          }
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: '{point.y}'
        },
        title: {
          text: `Toplam Parsel Sayısı`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          pointWidth: 110,
          data: [sanayiParsel, emptyParcelCount],
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });
    })
  }

  const getOsbler = async () => {
    const response = await axios.get(process.env.REACT_APP_BASE_URL +
      `rest/v1/geoserver/osb/ows?service=WFS&sortBy=id+A&version=1.0.0&cql_filter=il_kodu=${provinceID}&request=GetFeature&propertyName=id,adi,il_kodu&typeName=osb_sinir_usr&outputFormat=application/json&token=${token}`)
    const osbler = response.data.features.map((feature: any) => feature.properties);
    setOsbList(osbler);

  }

  return (
    <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <div className='rapor-column'>
          <Dropdown options={copyIller} value={provinceID} optionLabel='adi' optionValue='id' placeholder='İl Seçiniz' style={{ width: '200px' }} onChange={(e) => setProvinceID(e.value)}>
          </Dropdown>
        </div>
        <div style={{ display: 'flex', marginBottom: '10px' }}><Button className="pdf-button" label='PDF Dışa Aktar' onClick={downloadPdf} /></div>
      </div>
      <div className="rapor-column-container" id='tab3'>
        <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
          <div className='rapor-row' style={{ padding: '10px' }}>
            <div id='il_bar' className='rapor-column-element' style={{ width: '100%', height: '80%' }}>
            </div>
            <div style={{ padding: '1em', border: '1px solid var(--primary-color', margin: '1em 0', minHeight: '42vh' }}>
              <div style={{ textAlign: 'center', marginBottom: '0.5em' }}><strong>OSB Listesi</strong></div>
              {
                osbList && osbList.length > 0 && osbList.map((osb: any) =>
                  <li key={osb.id} style={{ padding: '0.2em' }}>
                    {osb.adi}
                  </li>
                )
              }
              {
                !osbList || osbList.length === 0 &&
                <div>Lütfen önce bir il seçiniz.</div>
              }
            </div>
          </div>
          <div className='rapor-row' style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div className='rapor-column' style={{ width: '100%', height: '50%' }}>
              {reportData && reportData.bolgeData.length === 1 &&
                <div id='test' style={{ width: '30%', height: '100%', marginRight: '8px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                  <div style={{ width: '90%', height: '30%' }}>
                    <RaporCard header="IBBSD-2 Bölge Adı" value={reportData.bolgeData.length === 1 ? reportData.bolgeData[0].i_adi : '-'}></RaporCard>
                  </div>
                  <div style={{ width: '90%', height: '30%' }}>
                    <RaporCard header="Teşvik Bölge Kodu" value={reportData.bolgeData.length === 1 ? reportData.bolgeData[0].t_adi : '-'}></RaporCard>
                  </div>
                  <div style={{ width: '90%', height: '30%' }}>
                    <RaporCard header="Coğrafi Bölge Adı" value={reportData.bolgeData.length === 1 ? reportData.bolgeData[0].c_adi : '-'}></RaporCard>
                  </div>
                </div>}
              <div id='il_parsel_bar' className='rapor-column-element' style={{ width: '100%', height: '100%', marginRight: '8px' }}>
              </div>
              <div id='il_doluluk' className='rapor-column-element' style={{ width: '40%', height: '100%' }}>
              </div>
            </div>
            <div className='rapor-column' style={{ width: '100%', height: '50%' }}>
              <div id='parsel_alan' className='rapor-column-element' style={{ width: '29%', height: '100%' }}>
              </div>
              <div id='parsel_sayi' className='rapor-column-element' style={{ width: '29%', height: '100%' }}>
              </div>
              <div id='card' className='rapor-column-element' style={{ width: '39%', height: '43vh', display: 'flex', flexDirection: 'column' }}>
                {reportData &&
                  <>
                    <div style={{ width: '100%', height: '50%', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="Bölge Büyüklüğü (ha)" value={areaFormatter.format(reportData.osbData[0].count.toFixed(2))}></RaporCard>
                      </div>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="Sanayi Parsel Planlanan Alan (ha)" value={areaFormatter.format(reportData.osbData[2].count.toFixed(2))}></RaporCard>
                      </div>
                    </div>
                    <div style={{ width: '100%', height: '50%', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="İşyeri Açma ve Çalışma Ruhsatı Alan Sayısı" value={areaFormatter.format(reportData.osbData[3].count)}></RaporCard>
                      </div>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="İstihdam Sayısı" value={areaFormatter.format(reportData.osbData[1].count)}></RaporCard>
                      </div>
                    </div>
                  </>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

